import React, { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "../../lib/api";

export default function AdminAirportInfo() {
  const [info, setInfo] = useState(null);
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");

  useEffect(() => { api.get("/airport-info").then((r) => setInfo(r.data)); }, []);

  if (!info) return <div>Loading…</div>;

  const upd = (k) => (e) => setInfo({ ...info, [k]: e.target.value });
  const updNum = (k) => (e) => setInfo({ ...info, [k]: parseInt(e.target.value) || 0 });
  const updList = (k) => (e) => setInfo({ ...info, [k]: e.target.value.split("\n").map((s) => s.trim()).filter(Boolean) });

  const save = async () => {
    setMsg(""); setErr("");
    try {
      const { data } = await api.put("/airport-info", info);
      setInfo(data);
      setMsg("Saved.");
    } catch (e) {
      setErr(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    }
  };

  return (
    <div data-testid="admin-airport-info">
      <div className="section-label">Field Profile</div>
      <h1 className="font-display font-bold text-3xl text-slate-950 mt-2">Airport Information</h1>

      <div className="mt-8 bg-white border border-slate-200 p-6 rounded-md grid sm:grid-cols-2 gap-4 max-w-4xl">
        <Field label="Name" value={info.name} onChange={upd("name")} />
        <Field label="Identifier" value={info.identifier} onChange={upd("identifier")} />
        <Field label="City" value={info.city} onChange={upd("city")} />
        <Field label="State" value={info.state} onChange={upd("state")} />
        <Field label="Elevation (ft)" type="number" value={info.elevation_ft} onChange={updNum("elevation_ft")} />
        <Field label="Pattern Altitude (ft)" type="number" value={info.pattern_altitude_ft} onChange={updNum("pattern_altitude_ft")} />
        <Field label="CTAF" value={info.ctaf} onChange={upd("ctaf")} />
        <Field label="AWOS" value={info.awos} onChange={upd("awos")} />
        <Field label="Runway" value={info.runway} onChange={upd("runway")} />
        <Field label="Hours" value={info.hours} onChange={upd("hours")} />
        <Field label="Phone" value={info.phone} onChange={upd("phone")} />
        <Field label="Email" value={info.email} onChange={upd("email")} />
        <Field label="Address" value={info.address} onChange={upd("address")} />
        <div className="sm:col-span-2">
          <label className="text-sm font-medium text-slate-900 mb-1 block">Description</label>
          <textarea rows={4} className="w-full border border-slate-300 px-3 py-2" value={info.description} onChange={upd("description")} />
        </div>
        <div className="sm:col-span-2">
          <label className="text-sm font-medium text-slate-900 mb-1 block">FBO Services (one per line)</label>
          <textarea rows={6} className="w-full border border-slate-300 px-3 py-2 font-mono-data text-sm" value={(info.fbo_services || []).join("\n")} onChange={updList("fbo_services")} />
        </div>
        <div className="sm:col-span-2 flex items-center gap-3">
          <button data-testid="info-save" onClick={save} className="bg-slate-950 text-white px-6 py-3 font-semibold hover:bg-slate-800">Save changes</button>
          {msg && <span className="text-emerald-600 text-sm">{msg}</span>}
          {err && <span className="text-red-600 text-sm">{err}</span>}
        </div>
      </div>
    </div>
  );
}

function Field({ label, value, onChange, type = "text" }) {
  return (
    <div>
      <label className="text-sm font-medium text-slate-900 mb-1 block">{label}</label>
      <input type={type} value={value ?? ""} onChange={onChange} className="w-full border border-slate-300 px-3 py-2" />
    </div>
  );
}
